import { useRef } from 'react';

import { Button } from '@frontend/components';

const UploadButton = ({
  accept,
  children,
  multiple,
  onClick = () => 0,
  onUpload,
  category,
  unstyled,
  ...props
}) => {
  const fileInputRef = useRef();

  const handleChange = () => {
    const files = [...fileInputRef.current.files];
    fileInputRef.current.value = '';
    const filesToUpload = multiple ? files : files[0];
    const uploadParams = category
      ? { category, file: filesToUpload }
      : filesToUpload;
    onUpload(uploadParams);
  };

  const handleClick = () => {
    onClick();
    fileInputRef.current.click();
  };
  return (
    <span
      data-testid="upload-button"
      style={{ width: '100%', display: 'block' }}
    >
      <input
        accept={accept}
        style={{ display: 'none' }}
        type="file"
        multiple={multiple}
        ref={fileInputRef}
        onChange={handleChange}
      />
      {unstyled ? (
        <button onClick={handleClick} {...props}>
          {children}
        </button>
      ) : (
        <Button onClick={handleClick} {...props}>
          {children}
        </Button>
      )}
    </span>
  );
};

export default UploadButton;
